import { defineMessages } from "react-intl";

import {
	psychiatricContraindicationMessages,
	validator
} from "lib/build/forms/ltx/phase-i/consultations/psychiatricAssessment";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	psychiatricAssessment: {
		id: "form.psychiatric_assessment",
		defaultMessage: "Pszichiátriai vélemény"
	},
	psychiatricContraindication: {
		id: "form.psychiatric_assessment.psychiatric_contraindication",
		defaultMessage: "Vélemény"
	}
});

const fields: { [key: string]: FieldData } = {
	psychiatricContraindication: {
		type: "field",
		path: ["psychiatricContraindication"],
		label: messages.psychiatricContraindication,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: psychiatricContraindicationMessages }
		}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.psychiatricContraindication }] }
	]
};

export const node: LeafNode = {
	id: "psychiatricAssessment",
	value: {
		title: messages.psychiatricAssessment,
		validator,
		fieldset
	}
};
